export const APP_NAME = "Curios";
export const APP_TAGLINE = "A conversational operating system.";
